<template>
  <div>
    <van-popup v-model="showPop" position="right" style="height: 100%; width: 80%" @click-overlay="closePopup">
      <div class="btn-wrap">
        <div class="pop-title">
          <p>搜索筛选区</p>
          <van-icon name="cross" @click="cancel" />
        </div>
      </div>
      <div class="input-wrap">
        <van-cell-group>
          <van-field readonly clickable v-model="queryParams.companyName" @click="showPicker('company')" label="签约主体机构" placeholder="选择签约主体机构" />
          <van-field v-model="queryParams.contractNum" label="合同编号" placeholder="请输入合同编号" />
          <van-field v-model="queryParams.contractName" label="合同标题" placeholder="请输入合同标题" />
          <van-field readonly clickable v-model="queryParams.businessTypeName" @click="showPicker2('service')" label="业务类型" placeholder="请选择业务类型" />
          <van-field readonly clickable v-model="queryParams.payTypeName" @click="showPicker('payType')" label="垫款方式" placeholder="选择垫款方式" />
          <van-field readonly clickable v-model="queryParams.frameTypeName" @click="showPicker('frameType')" label="框架类型" placeholder="选择框架类型" />
          <van-field v-model="queryParams.signedUser" label="对方签约人" placeholder="请输入对方签约人" />
          <van-field v-model="queryParams.signedUserMobile" label="对方电话" placeholder="请输入对方电话" />
          <van-field v-model="queryParams.signedUserWx" label="对方微信号" placeholder="请输入对方微信号" />
          <van-field readonly clickable v-model="deptName" @click="showPicker('dept')" label="我方签约部门" placeholder="选择我方签约部门" />
          <van-field v-model="queryParams.userName" label="我方签约人" placeholder="请输入我方签约人" />
          <!-- <van-field v-model="executionTime" readonly clickable name="calendar" label="执行时间" placeholder="点击选择执行时间" @click="showCalendar('executionTime')" /> -->
          <van-field v-model="signTime" readonly clickable name="calendar" label="添加日期" placeholder="点击选择添加日期" @click="showCalendar('signTime')" />

        </van-cell-group>
      </div>
      <div class="footer-btn-wrap">
        <van-button size="mini" type="primary" class="resetBtn" @click="resetQuery">重置</van-button>
        <van-button size="mini" type="info" class="submitbtn" @click="submitForm">搜索</van-button>
        <van-button size="mini" type="info" class="submitbtn" @click="cancel">取消</van-button>
      </div>
    </van-popup>
    <van-popup v-model="picker.visible" position="bottom">
      <van-picker :loading="picker.loading" :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" />
    </van-popup>
    <van-popup v-model="tree.typeTree" position="bottom">
      <van-cascader :title="tree.title" :options="tree.treeList" @change="treeChange" :field-names="tree.fieldNames" @close="tree.typeTree = false" @finish="onFinishTree" />
    </van-popup>

    <van-calendar v-model="datePicker.showDate" :min-date="datePicker.minDate" :max-date="datePicker.maxDate" :type="datePicker.type" @confirm="dateConfirm" />
  </div>
</template>

<script>
import { Field, Popup, Icon, Button, Cell, CellGroup, CollapseItem, Divider, Collapse, Calendar, Picker, Cascader } from 'vant'
import { businessTypeList, companyList } from '@/api/admi/dept'
import { getDicts } from '@/api/system/dict/data'
import statistics from '@/api/tongji/statistics'
export default {
  name: 'SearchPop',
  props: {
    show: Boolean
  },
  watch: {
    show: function (newVal, oldVal) { // 不能用箭头函数
      this.showPop = newVal
    }
  },
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Divider.name]: Divider,
    [Calendar.name]: Calendar,
    [Picker.name]: Picker,
    vanCascader: Cascader
  },
  data() {
    return {
      deptName: '',
      picker: {
        visible: false,
        title: '',
        columns: [],
        formKey: '',
        loading: false
      },
      tree: {
        type: '',
        title: '',
        typeTree: false,
        treeList: [],
        fieldNames: {

        }
      },
      datePicker: {
        showDate: false,
        minDate: new Date(2010, 0, 1),
        maxDate: new Date(2042, 0, 1),
        type: 'single',
        formKey: ''
      },
      executionTime: '',
      signTime: '',
      businessTypeName: '',
      serviceTypeTreeList: '',
      companyList: [], // 公司列表
      deptList: [], // 部门列表
      value: null,
      showPop: false,
      activeNames: ['1'],
      contractTypeIndex: null,
      contractStatusIndex: null,
      minDate: new Date(2010, 0, 1),
      minDateStart: new Date(2010, 0, 1),
      // businessTypeName: null,
      queryParams: {
        params: {
          beginTime: '',
          endTime: ''
        }
      },
      contractStatusName: '',
      options: {
        contractStatusOptions: []
      },
      // 合同类型
      contractTypeOptions: this.$store.state.dictOptions.contractType || [],
      // 合同状态
      contractStatusOptions: this.$store.state.dictOptions.contractStatus || [],
      // 产品类型列表
      businessTypeOptions: this.$store.state.dictOptions.businessTypeTree || []
    }
  },
  mounted() {
    // 框架类型
    getDicts('frame_type').then(res => {
      this.options.frameTypeOptions = res.data
    })
    // 垫款方式
    getDicts('buy_pay_type').then(res => {
      this.options.payTypeOptions = res.data
    })
  },
  methods: {
    handleClick(type, prop, index) {
      switch (type) {
        case 'contractType':
          this.queryParams.contractType = prop
          this.contractTypeIndex = index
          break
        case 'contractStatus':
          this.queryParams.contractStatus = prop
          this.contractStatusIndex = index
          break
        default:
          console.log('handleClick', type, prop)
      }
    },
    resetQuery() {
      this.businessTypeName = ''
      this.queryParams = {
        launchType: null,
        // contractStatus: null,
        custName: null,
        contractNum: null,
        contractName: null,
        signedUser: null,
        signedUserMobile: null,
        signedUserWx: null,
        userName: null,
        businessType: null,
        deptId: null,
        payType: null,
        payTypeName: null,
        frameType: null,
        frameTypeName: null,
        // params: null,
        serviceTypeId: null,
        businessTypeName: null,
        // signTime: '',
        // startTime: '',
        // endTime: ''
        params: {
          beginTime: '',
          endTime: '',
          beginZxTime: '',
          endZxTime: ''
        },
        companyName: null,
        companyId: null
      }
      this.value = null
      this.contractTypeIndex = null
      this.contractStatusIndex = null
      this.businessTypeName = null
      this.contractStatusName = null
      this.executionTime = null
      this.signTime = null
      this.deptName = null
    },
    cancel() {
      this.showPop = false
      this.$emit('update:show', false)
    },
    closePopup() {
      this.showPop = false
      this.$emit('update:show', false)
    },
    // formatDate(date) {
    //   // 时间格式化 2019-09-08
    //   let year = date.getFullYear();
    //   let month = date.getMonth() + 1;
    //   let day = date.getDate();
    //   return year + "-" + month + "-" + day;
    // },
    // onConfirm(date) {
    //   const [start, end] = date;
    //   this.showCalendar = false;
    //   this.value = `${this.formatDate(start)} - ${this.formatDate(end)}`;
    //   let params = {
    //     beginTime: this.formatDate(start),
    //     endTime: this.formatDate(end)
    //   }
    //   this.queryParams.params = params
    // },
    async showPicker(type) {
      this.picker.loading = true
      this.picker.columns = []
      this.picker.formKey = type
      const optionItem = type + 'Options'
      if (type === 'contractStatus') {
        if (this.options.contractStatusOptions.length == 0) {
          // 合同状态
          await getDicts('contract_status').then(res => {
            this.options.contractStatusOptions = res.data
          })
        }
        this.picker.columns = this.options[optionItem].map((ele) => ele.dictLabel)
      }
      if (type === 'company') {
        // 获取公司信息
        if (this.companyList.length == 0) {
          await companyList().then((response) => {
            this.companyList = response.rows
          })
        }
        this.picker.columns = this.companyList.map((ele) => ele.companyName)
      } else if (type === 'dept') {
      // 获取公司信息
        if (this.deptList.length == 0) {
          await statistics.getDeptList({ isBuss: '1' }).then((response) => {
            this.deptList = response.data
          })
        }
        this.picker.columns = this.deptList.map((ele) => ele.deptName)
      } else {
        this.picker.columns = this.options[optionItem].map((ele) => ele.dictLabel)
      }
      this.picker.loading = false
      this.picker.visible = true
    },
    pickerConfirm(value, key) {
      const optionItem = this.picker.formKey + 'Options'
      if (this.picker.formKey === 'company') {
        this.queryParams.companyName = this.companyList[key].companyName
        this.queryParams.companyId = this.companyList[key].companyId
      } else if (this.picker.formKey === 'dept') {
        this.deptName = this.deptList[key].deptName
        this.queryParams.deptId = this.deptList[key].deptId.toString()
      } else {
        const name = this.picker.formKey + 'Name'
        this.queryParams[this.picker.formKey] = this.options[optionItem][key].dictValue
        this.queryParams[name] = this.options[optionItem][key].dictLabel
        // this.queryParams[this.picker.formKey] = this.options[optionItem][key].dictValue
        // this.contractStatusName = this.options[optionItem][key].dictLabel
      }
      this.picker.visible = false
    },
    // 去除树形数据的空children
    removeEmptyChildren(node) {
      node.forEach(item => {
        if ('children' in item && item.children.length === 0) {
          delete item.children
        } else if ('children' in item && item.children.length) {
          this.removeEmptyChildren(item.children)
        }
      })
      return node
    },
    /** 转换业务类型数据结构 */
    getData (arr) {
      // 利用两层filter实现
      const data = arr.filter(item => {
        item.children = arr.filter(e => {
          return item.businessTypeId === e.parentId
        })
        return !item.parentId
      })
      return this.removeEmptyChildren(data)
    },
    async showPicker2(val) {
      if (val === 'dept') {
        // if(this.deptTreeList.length == 0){
        //   // 获取部门信息
        //   await CascaderTreeSelect().then((response) => {
        //     this.deptTreeList = response.data;
        //   })
        // }
        // this.tree = {
        //   type: val,
        //   title: '请选择所在部门',
        //   typeTree: true,
        //   treeList: this.deptTreeList,
        //   fieldNames: {}
        // }
      } else if (val === 'service') {
        if (this.serviceTypeTreeList.length == 0) {
          // 获取获取业务类型
          await businessTypeList({ pageNum: 1, pageSize: 500 }).then((response) => {
            if (response.code === 200) {
              this.serviceTypeTreeList = this.getData(response.rows)
            }
          })
        }
        this.tree = {
          type: val,
          title: '请选择业务类型',
          typeTree: true,
          treeList: this.serviceTypeTreeList,
          fieldNames: {
            text: 'businessTypeName',
            value: 'businessTypeId'
          }
        }
      }
    },
    showCalendar(type) {
      this.datePicker.formKey = type
      if (type === 'signTime' || type === 'executionTime') {
        this.datePicker.type = 'range'
      } else {
        this.datePicker.type = 'single'
      }
      this.datePicker.showDate = true
    },
    dateConfirm(date) {
      // this.minDate = date
      if (this.datePicker.formKey === 'signTime') {
        const [start, end] = date
        this.queryParams.params.beginTime = this.formatDate(start)
        this.queryParams.params.endTime = this.formatDate(end)
        this.signTime = `${this.formatDate(start)} 至 ${this.formatDate(end)}`
      } else if (this.datePicker.formKey === 'executionTime') {
        const [start, end] = date
        this.queryParams.params.beginZxTime = this.formatDate(start)
        this.queryParams.params.endZxTime = this.formatDate(end)
        this.executionTime = `${this.formatDate(start)} 至 ${this.formatDate(end)}`
      } else {
        this.queryParams[this.datePicker.formKey] = this.formatDate(date)
      }
      this.datePicker.showDate = false
    },
    formatDate(date) {
      // 时间格式化 2019-09-08
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      return year + '-' + month + '-' + day
    },
    treeChange(obj) {
      // if(this.tree.type === 'dept'){
      //   this.query.deptId = obj.value;
      //   this.deptName = obj.selectedOptions.map((option) => option.text).join("/")
      // }
      // console.log(this.query);
      if (this.tree.type === 'service') {
        // this.queryParams.serviceTypeId = obj.value
        this.queryParams.businessTypeName = obj.selectedOptions.map((option) => option.businessTypeName).join('/')
      }
    },
    onFinishTree(obj) {
      // if (this.tree.type === 'service') {
      //   this.queryParams.serviceTypeId = obj.value
      //   this.businessTypeName = obj.selectedOptions.map((option) => option.businessTypeName).join('/')
      // }
      // this.tree.typeTree = false
    },
    pickerCancel() {
      this.picker.visible = false
    },
    submitForm() {
      console.log(this.queryParams)
      this.$emit('handlequery', this.queryParams)
    }
  }
}
</script>
<style scoped lang="less">
@import url("@/style/index.less");
.btn-wrap {
  width: 100%;
  box-sizing: border-box;

  .pop-title {

    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 36px;
    font-weight: bold;
    padding: 0;
    padding: 0 30px;
  }
  .type-list {
    margin-bottom: 40px;

    .title {
      font-size: 28px;
      font-weight: bold;
    }
    .list-wrapper {
      line-height: 0.5;
    }
  }
  .input-wrap {
    margin-top: 20px;
  }
  .select_list {
    .van-button {
      margin-top: 10px !important;
      margin-bottom: 10px !important;
    }
  }
}
.footer-btn-wrap {
  position: fixed;
  bottom: 100px;
  padding: 20px;
  width: 100%;
  box-sizing: border-box;
  padding: 0 30px;

  display: flex;
  justify-content: space-around;

  .van-button {
    width: 45%;
    height: 60px;
    font-size: 30px;

    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  }
}
</style>
